import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import TouchableElement from '@components/common/touchableElement';
import Dropdown from '@components/common/dropdown';
import Svg from '@styles/icons/svg';
import { DASHBOARD_RESULT_TYPE_OPTIONS } from '@v2/pages/dashboard/common/constants/selections';
import { DASHBOARD_PRESS_HOVER_BG_COLOR } from '@v2/pages/dashboard/common/constants/colors';

import { useManageDashboardHeaderResultTypeChip } from './hooks/useManageDashboardHeaderResultTypeChip';
import DashboardDropdownSelectedIcon from '@v2/pages/dashboard/common/components/DashboardDropdownSelectedIcon';
import {DROPDOWN_CONFIG} from '@v2/pages/dashboard/common/constants/dropdown';

interface DashboardHeaderResultTypeChipProps extends WithColor {
  testID?: string;
}

const DashboardHeaderResultTypeChip: FC<DashboardHeaderResultTypeChipProps> = ({ C, testID }) => {
  const { resultType, currentLabel, onChange } = useManageDashboardHeaderResultTypeChip();

  return (
    <Dropdown
      items={DASHBOARD_RESULT_TYPE_OPTIONS}
      selectedValue={resultType}
      onChange={onChange}
      menuAlignment="left"
      menuStyle={{ width: undefined, minWidth: scale(DROPDOWN_CONFIG.minWidth) }}
      optionStyle={{ height: scale(40) }}
      withOptionDivider
      optionTextStyle={({ isSelected }) => ({
        ...font[isSelected ? 'Subhead 1 bold' : 'Subhead 2'],
        color: C(isSelected ? 'System/Light/Blue' : 'Label/Light/Primary'),
      })}
      selectedIcon={<DashboardDropdownSelectedIcon />}
      renderTrigger={({ triggerRef, onPress }) => (
        <TouchableElement testID={testID} onPress={onPress}>
          {({ boxStyle, pressHoverColor, hovered, pressed }) => (
            <View
              ref={triggerRef}
              style={[
                boxStyle,
                {
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: scale(4),
                  paddingVertical: scale(4),
                  paddingHorizontal: scale(8),
                  borderRadius: scale(8),
                  backgroundColor: C('Background/Light/Tertiary'),
                },
                (hovered || pressed) && {
                  backgroundColor: C(pressHoverColor(DASHBOARD_PRESS_HOVER_BG_COLOR)),
                },
              ]}
            >
              <Text style={[font['Button 2'], { color: C('Label/Light/Tertiary') }]}>{currentLabel}</Text>
              <Svg icon="chevronBottom" color="Label/Light/Tertiary" width={scale(15)} height={scale(16)} />
            </View>
          )}
        </TouchableElement>
      )}
    />
  );
};

export default ColorWrapper(DashboardHeaderResultTypeChip);
